const usersListTemplate = (editor) => {

    editor.BlockManager.add('usersListTemplate', {
        category: `Built In Templates`,
        label: `Users List Template`,
        attributes: {},
        content: `
        <nav class="navbar navbar-expand-sm navbar-light py-3 fs-3">
            <div class="container-fluid">
                <button
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#sidebar"
                    aria-controls="sidebar"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div
                    classtype='sidebar-container'
                    class="offcanvas offcanvas-start sidebar-container text-white"
                    id="sidebar"
                >
                    <div
                        class="offcanvas-header"
                        class="text-white fs-1"
                    >
                        <button
                            type="button"
                            class="text-white bg-transparent border-0 fs-1"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ><i class="bi-x text-white"></i></button>
                    </div>

                    <div class="offcanvas-body p-0">
                        <ul class="navbar-nav flex-column text-white h-100 py-5 ">
                            <li statype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Overview</span>
                                <i class="bi bi-house mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>List of Patients</span>
                                <i class="bi bi-people-fill mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Calendar</span>
                                <i class="bi bi-calendar-fill mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Notifications</span>
                                <i class="bi bi-bell-fill mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Messages</span>
                                <i class="bi bi-envelope-fill mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Preferences</span>
                                <i class="bi bi-gear-fill mx-5"></i>
                            </a>
                            </li>
                                
                        </ul>
                    </div>

                    <div class="offcanvas-footer">
                        <a class="d-flex align-items-center justify-content-end nav-link text-white pb-5" href="#!">
                            <span>Logout</span>
                            <i class="bi bi-box-arrow-right mx-5"></i>
                            </a>
                    </div>
                </div>
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav me-auto d-flex align-items-center justify-content-center">
                        <li
                            class="nav-item fs-1"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#sidebar"
                            aria-controls="sidebar"
                        >
                            <a
                                ><i classtype='text-green' class="bi bi-list text-green"></i
                            ></a>
                        </li>
                        <li class="nav-item nav-link" href="#!">
                            <a><i
                                    classtype='text-gray'
                                    class="bi bi-people text-gray"
                                ></i
                            ></a>
                        </li>
                    </ul>

                    <ul class="navbar-nav ms-auto  d-flex align-items-center justify-content-center">
                        <li class="nav-item nav-link" href="#!">
                            <a><i
                                    classtype='text-gray'
                                    class="bi bi-box-arrow-right text-gray"
                                ></i
                            ></a>
                        </li>
                        <li class="nav-item nav-link" href="#!">
                            <a><i
                                    classtype='text-gray'
                                    class="bi bi-gear-fill text-gray"
                                ></i
                            ></a>
                        </li>
                        <li class="nav-item nav-link pointer" href="#!">
                            <a class="position-relative"
                                ><i
                                    classtype='text-gray'
                                    class="bi bi-envelope-fill text-gray"
                                ></i
                            >
                            <span classtype="bg-green" class="position-absolute p-1 mt-2 ml-3 fs-6 top-0 start-50 translate-middle badge rounded-circle bg-green">
                                2 <!-- Number indicator -->
                                </span></a>
                        </li>
                        <li class="nav-item nav-link pointer" href="#!">
                            <a class="position-relative"
                                ><i
                                    classtype='text-gray'
                                    class="bi bi-bell-fill text-gray"
                                ></i
                            ><span classtype="bg-green" class="position-absolute p-1 mt-2 ml-3 fs-6 top-0 start-50 translate-middle badge rounded-circle bg-green">
                                4 <!-- Number indicator -->
                                </span></a>
                        </li>
                        <li classtype='text-green' class="nav-item nav-link pointer text-green" href="#!">
                            <p classtype='text-green' class="fw-bold text-green fs-5 my-auto"
                                >holoprac01</p
                            >
                        </li>
                        <li class="nav-item nav-link" href="#!">
                            <a>
                                <img
                                    src="https://i.ibb.co/7v05TmV/image.png"
                                    class="rounded-circle"
                                    alt="User Profile"
                                    width="50"
                                    height="50"
                                />
                            </a>
                        </li>
                        <li class="nav-item nav-link" href="#!">
                            <a class="navbar-brand"><img
                                    src="https://dummyimage.com/150x75/dee2e6/6c757d.jpg"
                                    alt="Logo"
                                    class="img-fluid"
                                    width="150"
                                    height="75"
                            /></a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="container p-3">
            <div>
                <button type="button" classtype='text-green' class="btn fs-2 fw-normal m-3 text-green">
                    <i class="bi bi-chevron-left"></i>List of Patients
                </button>
            </div>
            <div class="input-group col-8 col-sm-4 ms-auto mb-3 w-auto">
                <span classtype='searchbar-button' class="input-group-text searchbar-button w-auto border-0"
                    ><i class="bi bi-search text-white"></i
                ></span>
                <input
                    pseudotype='searchbar'
                    statetype='searchbar'
                    classtype='searchbar'
                    type="text"
                    class="form-control border-0 text-white searchbar"
                    placeholder="Search for a Patient"
                    aria-label="Search"
                    aria-describedby="search-icon"
                />
            </div>
            <div class="ms-auto col-4 d-flex justify-content-end">
                <button
                    classtype='list-button'
                    class="btn pointer my-4 px-4 py-3 ms-auto list-button border-0"
                >
                    <i class="bi bi-plus"></i> Add A New Patient
                </button>
            </div>

            <div class="container mb-3">
                <div class="row col-12 g-3 justify-content-center align-items-center" dataItems="getAllCards">
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser01</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser02</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser03</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser04</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser05</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser06</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser07</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser08</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser09</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser10</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser11</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser12</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser13</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0 ">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser14</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `
    })
}

export default usersListTemplate;